import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormComponent } from './form/form.component';
import { VisitFormComponent } from './visit-form/visit-form.component';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  standalone: false,
})
export class AboutComponent implements OnInit {
  @Input() school: any = {};
  images: any[] = [];
  currentIndex: number = 0;
  showOverlay: boolean = false;
  overlayIndex: number = 0;
  intervalId: any = null;
  isBrowser: boolean;
  schoolId: number = 0;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private dialog: MatDialog
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  currentImageIndex: number = 0;
  isFlipping: boolean = false;
  isFormVisible = false;
  isVisitFormVisible = false;
  formTitle = '';
  formSubmitButtonLabel = '';
  isEducationLevelRequired = false;

  ngOnInit(): void {
    this.initializeGallery();
    this.schoolId = this.school._id;
    // console.log(this.schoolId);
    if (this.isBrowser) {
      this.startSlideshow();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      this.initializeGallery();
      this.schoolId = this.school._id;
      // this.schoolId = this.school._id;
      // console.log(this.schoolId);
      if (this.isBrowser) {
        this.stopSlideshow();
        this.startSlideshow();
      }
    }
  }

  openFormDialog(): void {
    const dialogRef = this.dialog.open(FormComponent, {
      width: '500px',
      data: {
        id: this.schoolId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed with result:', result);
    });
  }

  openVisitForm(): void {
    const dialogRef = this.dialog.open(VisitFormComponent, {
      width: '500px',
      data: {
        id: this.schoolId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log('Dialog closed with result:', result);
    });
  }

  ngOnDestroy(): void {
    this.stopSlideshow();
  }

  initializeGallery(): void {
    this.images = this.school?.gallery;
  }

  startSlideshow(): void {
    this.stopSlideshow();
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 3000);
  }

  stopSlideshow(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  openImage(index: number): void {
    this.stopSlideshow();
    this.showOverlay = true;
    this.overlayIndex = index;
  }

  closeOverlay(): void {
    this.showOverlay = false;
    if (this.isBrowser) {
      this.startSlideshow();
    }
  }

  prevImage(): void {
    this.overlayIndex =
      (this.overlayIndex - 1 + this.images.length) % this.images.length;
  }

  nextImage(): void {
    this.overlayIndex = (this.overlayIndex + 1) % this.images.length;
  }

  // showForm(type: string) {
  //   this.isFormVisible = true;

  //   if (type === 'admission') {
  //     this.formTitle = 'Admission Contact Form';
  //     this.formSubmitButtonLabel = 'Submit details';
  //     this.isEducationLevelRequired = true;
  //   } else if (type === 'booking') {
  //     this.formTitle = 'Book a Tour';
  //     this.formSubmitButtonLabel = 'Book tour';
  //     this.isEducationLevelRequired = true;
  //   }
  // }
  // showVisitForm() {
  //   this.isVisitFormVisible = true;
  // }
  // hideVisitForm() {
  //   this.isVisitFormVisible = false;
  // }

  // hideForm() {
  //   this.isFormVisible = false;
  // }

  handleFormSubmission(formData: any) {}
}
